module.exports = __webpack_public_path__ + "img/shyk.4230f9e7.png";